<script setup>
import { Star } from 'lucide-vue'
import AsyncButton from './AsyncButton.vue'
import { useFavourites } from '@/composables/favourites'

defineProps({
  id: { type: Number, required: true },
  type: { type: String, required: true },
})

const {
  favourites,
  addFavourite,
  removeFavourite,
} = useFavourites()
</script>

<template>
  <AsyncButton
    v-if="favourites[type]?.some(f => f.id === id)"
    v-tippy.left="$t('App.Favourites.Remove')"
    class="text-microsoft-blue-default p-0.5 hover:bg-microsoft-azure transition rounded-md disabled:text-neutral-gray-400 disabled:hover:bg-neutral-gray-300"
    @click="removeFavourite(id, type)"
  >
    <Star class="h-4 w-4 fill-[currentColor]" />
  </AsyncButton>
  <AsyncButton
    v-else
    v-tippy.left="$t('App.Favourites.Add')"
    class="text-microsoft-blue-default p-0.5 hover:bg-microsoft-azure transition rounded-md disabled:text-neutral-gray-400 disabled:hover:bg-neutral-gray-300"
    @click="addFavourite(id, type)"
  >
    <Star class="h-4 w-4" />
  </AsyncButton>
</template>
